import { fontVariablesClassName } from './fonts';

export const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className={`${fontVariablesClassName} font-sans`}>{children}</div>
);
